import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { CREATE_OR_UPDATE_ABSATZ_UMSATZ_PLANWERT_AND_INTERNE_NOTIZ } from './graphql/mutations';
import {
  CreateOrUpdateAbsatzUmsatzPlanWertAndInterneNotizMutation,
  CreateOrUpdateAbsatzUmsatzPlanWertAndInterneNotizMutationVariables,
} from '@/gql/graphql';

export function useAbsatzUmsatzPlanWertCreateOrUpdate() {
  const [execute, result] = useMutation<
    CreateOrUpdateAbsatzUmsatzPlanWertAndInterneNotizMutation,
    CreateOrUpdateAbsatzUmsatzPlanWertAndInterneNotizMutationVariables
  >(CREATE_OR_UPDATE_ABSATZ_UMSATZ_PLANWERT_AND_INTERNE_NOTIZ, {
    refetchQueries: [
      'getPlanwerteByStandortId',
      'getHistorie',
      'getTagebuchEintraegeByStandortIds',
    ],
  });

  const createOrUpdateAbsatzUmsatzPlanWert = useCallback(
    (
      variables: CreateOrUpdateAbsatzUmsatzPlanWertAndInterneNotizMutationVariables,
    ) => {
      return execute({ variables });
    },
    [execute],
  );

  return [createOrUpdateAbsatzUmsatzPlanWert, result] as const;
}
